export const updateExcerpt = (excerpt: string) => { // replace <mark> tags with ``
    if (excerpt) {
        excerpt = excerpt.replace(/<mark>/g, "");
        excerpt = excerpt.replace(/<\/mark>/g, "");
    }
    return excerpt;
};
